import { ReactElement } from 'react'

import { ExpertBalanceSheetTab, ExpertBalanceSheetViewMode } from '../../types/expertBalanceSheetView'
import { ExpertBalanceSheetExportMenu } from '../ExpertBalanceSheetExportMenu'
import { ExpertBalanceSheetTabs } from '../ExpertBalanceSheetTabs'
import { ExpertBalanceSheetViewModeToggle } from '../ExpertBalanceSheetViewModeToggle'
import * as Styled from './styles'

interface ExpertBalanceSheetToolbarProps {
  activeTab: ExpertBalanceSheetTab
  onTabChange: (tab: ExpertBalanceSheetTab) => void
  onViewModeChange: (viewMode: ExpertBalanceSheetViewMode) => void
  viewMode: ExpertBalanceSheetViewMode
}

export const ExpertBalanceSheetToolbar = ({
  activeTab,
  onTabChange,
  onViewModeChange,
  viewMode,
}: ExpertBalanceSheetToolbarProps): ReactElement => (
  <Styled.ToolbarWrapper>
    <ExpertBalanceSheetTabs activeTab={activeTab} onTabChange={onTabChange} />
    <Styled.ToolbarActions>
      <ExpertBalanceSheetViewModeToggle onViewModeChange={onViewModeChange} viewMode={viewMode} />
      <ExpertBalanceSheetExportMenu />
    </Styled.ToolbarActions>
  </Styled.ToolbarWrapper>
)
